// metadata_editor.js
// Used to edit the metadata field for a Zettel.
// FIXME: This editor becomese obsolete and can be deleted once the metadata field is
// editable in a Zettel popout.
import { EditorView, placeholder as placeholderExtension } from "@codemirror/view";
import { keymap } from "@codemirror/view";
import { markdown } from "@codemirror/lang-markdown"
import { defaultKeymap, history, historyKeymap } from "@codemirror/commands"
import { syntaxHighlighting, defaultHighlightStyle } from "@codemirror/language"

// THEME
import { witerDark } from './themes/witerDarkTheme'

export class MetadataEditor {
  constructor({ parent, initialValue, onChange, boxSlug, placeholder = 'Metadata goes here. Just make sure you know what you are doing' }) {
    this.editorView = new EditorView({
      doc: initialValue || '',
      extensions: [
        markdown(),
        history(),
        keymap.of([
          ...defaultKeymap,
          ...historyKeymap
        ]),
        EditorView.lineWrapping,
        syntaxHighlighting(defaultHighlightStyle),
        witerDark,
        EditorView.updateListener.of((update) => {
          if (update.docChanged && onChange) {
            onChange(update.state.doc.toString())
          }
        }),
        placeholderExtension(placeholder)
      ],
      parent
    })

    this.editorView.dom.style.minHeight = "200px"
  }

  destroy() {
    this.editorView.destroy()
  }
}
